<div class="tt-o-menu">
  <slot name="menuTrigger"></slot>
  <slot></slot>
</div>



// WEBPACK FOOTER //
// ./src/objects/menu/menu.html